import Main from "@root/Main";
import { ComponentDefineDic, ComponentElem } from "@components/interfaces";
import Components from "@components/Compoents";
import ProductNav from "./ProductNav";
import PlanSelect from "./PlanSelect";
import PlanOption from "./PlanOption";
import PlanTimeSelect from "./PlanTimeSelect";
import PlanUnitCount from "@components/ui/PlanUnitCount";
import PlanResult from "./PlanResult";
import PlanUnitCountResult from "@components/product/PlanUnitCountResult";
import ProductPromote from "./ProductPromote";
import GoogleMap from "@components/ui/GoogleMap";
import RatingStars from "@components/ui/RatingStars";
import ReviewPhotoList from "./ReviewPhotoList";
import ProductOutline from "./ProductOutline";
import ReviewList from "./ReviewList";
import Review from "./Review";
import ReviewRating from "./ReviewRating";
import PromoteList from "../ui/PromoteList";
import { ScrollListener } from "@ts/sframe/ScrollListener";
import ViewportRoot from "@ts/sframe/ViewportRoot";
import ImageSlider from "@components/ui/ImageSlider";
import ProductGallery from "./ProductGallery";
import Tools from "@ts/Tools";
import CollapseButton from "../ui/buttons/CollapseButton";
import { Product } from "./ProductTypes";
import ApiProxy from "@root/ts/ApiProxy";
import CartCookie from "../shared/CartCookie";
import page_data_schema from "@schema/product/page-data.json";
import review_schema from "@schema/review.json";
import AjvProxy from "../../ts/AjvProxy";

let _componentDic: ComponentDefineDic = {
  "product-outline": { componentClass: ProductOutline },
  "product-nav": { componentClass: ProductNav },
  "plan-select": { componentClass: PlanSelect },
  "plan-option": { componentClass: PlanOption },
  "plan-time-select": { componentClass: PlanTimeSelect },
  "plan-unit-count": { componentClass: PlanUnitCount },
  "plan-unit-count-result": { componentClass: PlanUnitCountResult },
  "plan-result": { componentClass: PlanResult },
  "product-promote": { componentClass: ProductPromote },
  "google-map": { componentClass: GoogleMap },
  "review-rating": { componentClass: ReviewRating },
  "rating-stars": { componentClass: RatingStars },
  "review-photo-list": { componentClass: ReviewPhotoList },
  "review-list": { componentClass: ReviewList },
  "review": { componentClass: Review },
  "promote-list": { componentClass: PromoteList },
  "image-slider": { componentClass: ImageSlider },
}

let $root: JQuery;

Main.preInitPage = () => {
  AjvProxy.addSchema(review_schema);
  ApiProxy.validatePageData("page-data", page_data_schema);
}

Main.initPage = () => {
  $root = $('#page-content');
  initCartCookie();
  build();
  applyCartRecord();
}

function build() {
  let collapseButton = Tools.seekComponentById("btn-collapse") as CollapseButton;
  collapseButton.emitter.on("change", (isCollapsed: string) => {
    if (isCollapsed === "true")
      ProductNav.instance.to("#product-detail-1");
  });

  ProductNav.instance.emiiter.addListener("triggered", (isCollapseAbleContent: boolean) => {
    if (isCollapseAbleContent)
      collapseButton.toggleCollapse(false);
  });

  let markElem = $root.find(".stick-mark")[0];
  let planSelectElem = $root.find("#product-plan-select")[0];
  let mobilePromoteTag = $root.find("#mobile-promote-tag")[0];

  // 調整優位價格置底 sticky
  ScrollListener.addListener("product-stick-mark", () => {
    if (ViewportRoot.index !== 0) {
      let rect = markElem.getBoundingClientRect(),
        $promote2 = $root.find(".promote-2"),
        blockHeight = $promote2[0].getBoundingClientRect().height,
        navHeight = ViewportRoot.index === 0 ? 60 : 70,
        productNavHeight = ViewportRoot.index === 0 ? 50 : 50,
        blockMarginTop = ViewportRoot.index === 0 ? 50 : 50,
        blockMarginBottom = ViewportRoot.index === 0 ? 50 : 50,
        minTop = navHeight + productNavHeight + blockMarginTop + blockHeight + blockMarginBottom,
        dy = rect.top - minTop;

      $promote2.css("top", dy < 0 ? dy + "px" : 0);
    } else {
      let rect = planSelectElem.getBoundingClientRect();
      let isPlanSelectVisible = Tools.testRectOverlapY(rect, ViewportRoot.boundingRect);
      mobilePromoteTag.setAttribute("active", isPlanSelectVisible ? "false" : "true");
    }
  });
  new ProductGallery($root.find(`[component="product-gallery"]`)[0] as ComponentElem);
}

function applyCartRecord() {
  let pageData: Product.PageData = ApiProxy.getPageData();
  let cartRecord = pageData.cart_record;
  if (cartRecord) {
    let planSelect: PlanSelect = ($root.find(`[component="plan-select"]`)[0] as ComponentElem)._component;
    planSelect.applyCartItem();
  }
}

function initCartCookie() {
  let commonPageData = ApiProxy.getCommonPageData();
  if (commonPageData.login_state.is_login)
    CartCookie.init();
}

Components.registComponents(_componentDic);

